import { render, staticRenderFns } from "./PlansAdd.vue?vue&type=template&id=9dbc822a&"
import script from "./PlansAdd.vue?vue&type=script&lang=js&"
export * from "./PlansAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports